import React from 'react';
import classnames from 'classnames';
import * as helper from '../../util/helper';
import * as urlHelper from '../../util/url';
import * as html from '../../util/html';
import * as richeditorHelper from '../../util/richeditHelper';
import * as linkUrl from '../../util/linkUrlJsonString';

require('./showfield.scss');
const STYLE_TITLE_UP_AND_DOWN = 'upAndDown';
class ShowField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: '',
            dfsUrl: {}
        };
        this.onTouchTapLink = this.onTouchTapLink.bind(this);
        this.isLink = this.isLink.bind(this);
    }

    componentDidMount() {
        const right = this.refs.rights.offsetWidth;
        const all = this.refs.all.offsetWidth;
        this.setState({ width: all - right - 10 + 'px' });
        const { value, cmpType } = this.props;
        const isRichEditor = cmpType === 'BC_TextAreaRTF';
        if (isRichEditor) {
            // 富文本中的图片根据dfs内容发请求返回的地址才是图片的地址
            richeditorHelper.replaceImgUrl(
                html.decode(value || ''),
                isRichEditor,
                (srcUrl, ClientUrl) => {
                    let { dfsUrl } = this.state;
                    dfsUrl[srcUrl] = ClientUrl;
                    this.setState({ dfsUrl: dfsUrl }, this.forceUpdate());
                }
            );
        }
    }

    shouldComponentUpdate(nextprops, nextState) {
        if (
            nextprops.value != this.props.value ||
            nextprops.text != this.props.text ||
            JSON.stringify(nextState) != JSON.stringify(this.state)
        ) {
            return true;
        }
        return false;
    }

    onTouchTapLink(e) {
        e.preventDefault();
        let {
            isLink,
            linkURL,
            cmpType,
            refMetaObjectName,
            id,
            OpenTarget,
            form_context
        } = this.props;
        if (isLink) {
            //对linkURL进行format
            linkURL = urlHelper.formatUrl(
                linkURL,
                helper.getQueryObject(),
                form_context,
                this.bizData()
            );
            let jumpUrl = '';
            if ('BC_LookUp,BC_LookUpV2'.indexOf(cmpType) >= 0) {
                if (refMetaObjectName) {
                    jumpUrl =
                        '#/DetailPage?metaObjName=' +
                        refMetaObjectName +
                        '&id=' +
                        id +
                        '&formState=show';
                } else {
                    return;
                }
            } else {
                const url = this.props.metaObjectName
                    ? `#/DetailPage?metaObjName=${
                          this.props.metaObjectName
                      }&id={data._id}&formState=show`
                    : '#/DetailPage?metaObjName={context.metaObjName}&id={data._id}&formState=show';
                jumpUrl = urlHelper.formatUrl(
                    url,
                    helper.getQueryObject(),
                    form_context,
                    this.bizData()
                );
            }
            const linkUrlString = linkURL && linkUrl.linkUrlJsonString(linkURL);
            let urlover =
                BSGlobal.application === 'ApprovalCentre'
                    ? linkUrlString.url || linkUrlString || jumpUrl
                    : urlHelper.androidChangeTime_stampToSearch() +
                      (linkUrlString.url || linkUrlString || jumpUrl);
            helper.pageJump(urlover, {
                openModel: OpenTarget || '',
                hasShadowContext:
                    typeof linkUrlString.hasShadowContext !== 'undefined'
                        ? linkUrlString.hasShadowContext
                        : true
            });
        } else {
            return;
        }
    }

    bizData() {
        const bizData = this.props.bizData;
        let kv = {};
        for (let prop in bizData) {
            kv[prop] = (bizData[prop] && bizData[prop].value) || '';
        }
        return kv;
    }

    isLink() {
        const { isLink, cmpType, refMetaObjectName } = this.props;
        return (
            isLink &&
            !(
                'BC_LookUp,BC_LookUpV2'.indexOf(cmpType) >= 0 &&
                !refMetaObjectName
            )
        );
    }

    render() {
        const { styleTitle, value } = this.props;
        //换行符16进制：0x0a，8进制：12
        const reg = /\12/g;
        let textAreaVlaue = this.props.value;
        if (this.props.cmpType === 'BC_TextAreaRTF') {
            const { dfsUrl } = this.state;
            if (
                textAreaVlaue &&
                textAreaVlaue.length > 0 &&
                JSON.stringify(dfsUrl) !== '{}'
            ) {
                for (let i in dfsUrl) {
                    textAreaVlaue = textAreaVlaue.replace(i, dfsUrl[i]);
                }
            }
        }
        const isUpAndDown = styleTitle === STYLE_TITLE_UP_AND_DOWN;
        const contentClass = classnames('showField-content',{
            'showField-right': !isUpAndDown,
            'showField-bottom': isUpAndDown,
            'clear-margin-top': isUpAndDown && !value,
            isLink: this.isLink()
        });

        return (
            <div
                className={classnames('showField', this.props.cls)}
                ref="all"
                onTouchTap={() => {}}>
                <div
                    className={classnames('showField-label', {
                        'showField-left': !isUpAndDown,
                        'showField-top': isUpAndDown
                    })}
                    style={{ width: this.state.width }}>
                    {this.props.text + ':'}
                </div>
                {this.props.cmpType === 'BC_TextAreaRTF' ? (
                    <div
                        className={contentClass}
                        ref="rights"
                        dangerouslySetInnerHTML={{
                            __html: html.decode(
                                textAreaVlaue &&
                                    textAreaVlaue.replace(reg, '<br/>')
                            )
                        }}
                        onTouchTap={this.onTouchTapLink}
                    />
                ) : (
                    <div
                        className={contentClass}
                        ref="rights"
                        onTouchTap={this.onTouchTapLink}>
                        <span className="content">{this.props.value}</span>
                    </div>
                )}
            </div>
        );
    }
}

ShowField.defaultProps = {
    text: '',
    value: ''
};

export default ShowField;



// WEBPACK FOOTER //
// ./src/components/Field_Components/ShowField/ShowField.js